
<div class="wrapper">
    <header class="header navbar navbar-expand-md row">
        <h2 class="col col-sm-7">RTO Exam Preparation</h2>
        <div class="row col col-sm-5">
            <div class="login-btn col col-sm-6">
                <a href="index.html"><button class="btn-fill"><p>HOME</p></button></a>
            </div>            
            <div class="login-btn col col-sm-6">
                <a href="login.html"><button class="btn-fill"><p>LOGIN</p></button></a>
            </div>
        </div>        
    </header>    
    <section class="container">                
        <!-- <div class="wrapper"> -->
            <div class="instruction">
                <h3>Instruction:</h3>
                <p>There are 15 Question.</p>
                <p>You have 45sec. For earh Question.</p>
                <p>You Must Answer 12 Questions Correctly to get Qualified for LLR Exam.</p>
            </div>
            <div class="question">
                <div class="que-main-head row">
                    
                    <div class="time-icon col col-sm-2 col-xl-2 col-12">
                        <div *ngFor="let i of dummy">
                            <circle-progress
                                [percent]="tsec"
                                [title]="psec"
                            ></circle-progress>
                        </div>
                    </div>
                    
                    <div class="que-head col col-sm-10 col-xl-10 col-12">
                        <div *ngIf="ques?.length > 0; else  quefail">
                            <h1>Question {{ qnpr+1 }}/15:</h1>
                            <h3>{{ ques[qnpr].que }}</h3>
                        </div>
                        <div *ngIf="ques[qnpr].hasImg">                
                            <img src="../../../assets/QueImg/{{ ques[qnpr].imgurl }}">                            
                        </div>
                    </div>
                </div>
                <div class="option-area">
                    
                        <div *ngIf="ques?.length > 0; else  quefail">                            
                            <div [(ngModel)]="selected" name="option" ngDefaultControl>
                                
                                    <div *ngFor="let option of [ques[qnpr].op1,ques[qnpr].op2,ques[qnpr].op3]">
                                        <div class="option">
                                            <!-- <input id="{{i}}" type="checkbox" [(ngModel)]="i.Selected" (change)="onSelect(ques[qnpr], i);" /> -->
                                            <input type="radio" value="{{ option }}" name="oop" (change)="onSelect(ques[qnpr],$event)">
                                            <p>{{ option }}</p>
                                        </div>                                        
                                    </div>                                                                 
                                <!-- <div class="option" [value]="1">
                                    <input id="{{option.Id}}" type="checkbox" [(ngModel)]="option.Selected" (change)="onSelect(question, option);" />
                                    <input TYPE="RADIO" VALUE="C" NAME="aa"> 
                                    <p>{{ ques[qnpr].op1 }}</p>
                                </div>
                                <div class="option" [value]="2">
                                    <input id="{{option.Id}}" type="checkbox" [(ngModel)]="option.Selected" (change)="onSelect(question, option);" />
                                    <input TYPE="RADIO" VALUE="C" NAME="aa"> 
                                    <p>{{ ques[qnpr].op2 }}</p>
                                </div>
                                <div class="option" [value]="3">
                                    <input TYPE="RADIO" VALUE="C" NAME="aa"> 
                                    <input id="{{option.Id}}" type="checkbox" [(ngModel)]="option.Selected" (change)="onSelect(question, option);" />
                                    <p>{{ ques[qnpr].op3 }}</p>
                                </div> -->
                                <div *ngIf="qnpr!=14">
                                    <button type="submit" id="submitbtn" class="btn-fill" (click)="AnswerQue()">Next</button>            
                                </div>
                                <div *ngIf="qnpr==14">
                                    <button type="submit" id="submitbtn" class="btn-fill" (click)="AnswerQue()">Submit</button>            
                                </div>        
                            </div>
                                                        
                        </div>
                        
                        <ng-template #quefail>
                            <p>If Question is not available Restart it.</p>
                            <button type="submit" id="submitbtn" class="btn-fill" (click)="Restartonfail()">Restart</button>
                        </ng-template> 
                        
                        <!-- <div *ngFor="let option of [ques[qnpr].op1,ques[qnpr].op2,ques[qnpr].op3]">
                            <p>{{ option }}</p>
                        </div> -->
                        
                </div>
            </div>
        
            <!-- <div *ngIf="ques">                
                <p>{{ ques[qnpr].ans }}</p>                
            </div> -->
    </section>
    <footer class="footer">    
        <h5>coyright &copy; 2020,MS-creation</h5>
    </footer>
</div>